// // import styled, { keyframes } from 'styled-components';
// // import { darken } from 'polished';

// // /* ===== Paleta / identidade visual (alinhada às telas de login) =====
// //    --primary:        #ff6d3c
// //    --primary-strong: #e95a2d
// //    --blue:           #1789dd
// //    --text:           #17263b / #2c405a
// //    --muted:          rgba(44, 64, 90, 0.55)
// //    --border:         rgba(216, 224, 235, 0.9)
// // ==================================================================== */

// // const fadeDown = keyframes`
// //   from { opacity: 0; }
// //   to   { opacity: 1; }
// // `;

// // const dropIn = keyframes`
// //   from { opacity: 0; transform: translateX(-50%) translateY(-8px) scale(0.97); }
// //   to   { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
// // `;

// // const badgePop = keyframes`
// //   0%   { transform: scale(0); }
// //   60%  { transform: scale(1.18); }
// //   100% { transform: scale(1); }
// // `;

// // export const Container = styled.nav`
// //   position: relative;
// //   z-index: 1;
// //   display: flex;
// //   align-items: center;
// //   min-height: 76px;
// //   padding: 0 26px;
// //   margin: 0 auto;
// //   width: 100%;
// //   max-width: 2000px;

// //   background: linear-gradient(
// //     180deg,
// //     rgba(255, 255, 255, 0.96) 0%,
// //     rgba(247, 250, 253, 0.94) 100%
// //   );
// //   border-bottom: 1px solid rgba(216, 224, 235, 0.7);
// //   box-shadow: 0 10px 32px rgba(23, 38, 59, 0.08),
// //     0 1px 0 rgba(255, 255, 255, 0.9) inset;
// //   animation: ${fadeDown} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;

// //   /* fina linha de acento na base, no degradê da marca */
// //   &::after {
// //     content: '';
// //     position: absolute;
// //     left: 0;
// //     right: 0;
// //     bottom: -1px;
// //     height: 2px;
// //     background: linear-gradient(rgba(23, 137, 221, 0.5) 100%);
// //     opacity: 0.85;
// //     pointer-events: none;
// //   }

// //   img {
// //     max-height: 56px;
// //     width: auto;
// //     transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), filter 0.3s ease;

// //     &:hover {
// //       transform: translateY(-1px) scale(1.02);
// //       filter: drop-shadow(0 8px 18px rgba(23, 38, 59, 0.16));
// //     }
// //   }

// //   & > ul {
// //     flex: 1;
// //     display: flex;
// //     align-items: center;
// //     gap: 4px;
// //     padding: 0 22px;
// //     height: 100%;

// //     /* separador "|" entre grupos do menu, repaginado como divisor suave */
// //     & > span {
// //       width: 1px;
// //       height: 24px;
// //       margin: 0 12px;
// //       color: transparent;
// //       background: linear-gradient(
// //         180deg,
// //         transparent,
// //         rgba(44, 64, 90, 0.22),
// //         transparent
// //       );
// //       overflow: hidden;
// //     }
// //   }

// //   @media (max-width: 900px) {
// //     padding: 0 16px;

// //     & > ul {
// //       padding: 0 10px;
// //       gap: 2px;
// //     }

// //     img {
// //       max-height: 46px;
// //     }
// //   }
// // `;

// // export const Menu = styled.li`
// //   position: relative;
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   height: 100%;
// //   min-width: 120px;

// //   font-size: 13px;
// //   font-weight: 800;
// //   letter-spacing: 0.4px;
// //   text-transform: uppercase;

// //   & + li {
// //     margin-left: 6px;
// //   }

// //   /* pílula de fundo para item ativo / hover */
// //   a,
// //   .bi-menu-button {
// //     position: relative;
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     gap: 4px;
// //     padding: 10px 16px;
// //     border-radius: 12px;

// //     color: ${(props) =>
// //       props.selected ? '#1f2f46' : 'rgba(44, 64, 90, 0.55)'};
// //     background: ${(props) =>
// //       props.selected ? 'rgba(255, 109, 60, 0.1)' : 'transparent'};

// //     transition: color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease,
// //       transform 0.22s ease;

// //     &:hover {
// //       color: ${darken(0.08, '#1f2f46')};
// //       background: rgba(255, 109, 60, 0.2);
// //       transform: translateY(-1px);
// //     }
// //   }

// //   /* indicador inferior animado (substitui o border-bottom antigo) */
// //   a::after,
// //   .bi-menu-button::after {
// //     content: '';
// //     position: absolute;
// //     left: 50%;
// //     bottom: -2px;
// //     height: 1px;
// //     width: ${(props) => (props.selected ? '60%' : '0')};
// //     border-radius: 999px;
// //     background: linear-gradient(90deg, #ff6d3c, #ff9b78);
// //     box-shadow: 0 4px 12px rgba(255, 109, 60, 0.45);
// //     transform: translateX(-50%);
// //     transition: width 0.28s cubic-bezier(0.22, 1, 0.36, 1);
// //   }

// //   a:hover::after,
// //   .bi-menu-button:hover::after {
// //     width: 80%;
// //   }

// //   /* ===== Botão "BI" ===== */
// //   .bi-menu-button {
// //     border: 0;
// //     font: inherit;
// //     font-size: 13px;
// //     font-weight: 800;
// //     letter-spacing: 0.4px;
// //     text-transform: uppercase;
// //     cursor: pointer;

// //     svg {
// //       transition: transform 0.25s ease;
// //     }

// //     &:hover svg {
// //       transform: translateY(1px);
// //     }
// //   }

// //   /* ===== Dropdown do BI ===== */
// //   .bi-menu-dropdown {
// //     position: absolute;
// //     top: calc(100% + 10px);
// //     left: 50%;
// //     transform: translateX(-50%);
// //     z-index: 9999;

// //     min-width: 224px;
// //     max-width: 300px;
// //     padding: 8px;

// //     background: rgba(255, 255, 255, 0.98);
// //     border: 1px solid rgba(216, 224, 235, 0.9);
// //     border-radius: 16px;
// //     box-shadow: 0 24px 60px rgba(23, 38, 59, 0.18),
// //       0 1px 0 rgba(255, 255, 255, 0.9) inset;
// //     backdrop-filter: blur(20px);
// //     animation: ${dropIn} 0.22s cubic-bezier(0.22, 1, 0.36, 1) both;

// //     /* seta apontando para o botão */
// //     &::before {
// //       content: '';
// //       position: absolute;
// //       top: -6px;
// //       left: 50%;
// //       width: 12px;
// //       height: 12px;
// //       transform: translateX(-50%) rotate(45deg);
// //       background: rgba(255, 255, 255, 0.98);
// //       border-left: 1px solid rgba(216, 224, 235, 0.9);
// //       border-top: 1px solid rgba(216, 224, 235, 0.9);
// //     }

// //     button {
// //       position: relative;
// //       display: flex;
// //       flex-direction: row;
// //       align-items: center;
// //       gap: 10px;

// //       width: 100%;
// //       border: 0;
// //       border-radius: 11px;
// //       padding: 11px 13px;
// //       background: transparent;

// //       text-align: left;
// //       text-transform: none;
// //       letter-spacing: 0;
// //       font-size: 13px;
// //       font-weight: 700;
// //       color: #3a4d66;
// //       cursor: pointer;

// //       transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;

// //       svg {
// //         flex-shrink: 0;
// //         color: #ff6d3c;
// //         transition: transform 0.2s ease;
// //       }

// //       &:hover {
// //         color: #17263b;
// //         background: rgba(255, 109, 60, 0.1);
// //         transform: translateX(2px);

// //         svg {
// //           transform: scale(1.12) rotate(-6deg);
// //         }
// //       }
// //     }
// //   }

// //   @media (max-width: 900px) {
// //     min-width: auto;

// //     a,
// //     .bi-menu-button {
// //       padding: 8px 11px;
// //       font-size: 12px;
// //     }
// //   }
// // `;

// // export const User = styled.div`
// //   display: flex;
// //   align-items: center;
// //   gap: 4px;

// //   & > h4 {
// //     padding: 8px 14px;
// //     border-radius: 999px;
// //     border: 1px solid rgba(216, 224, 235, 0.9);
// //     background: rgba(247, 250, 253, 0.8);

// //     font-size: 13px;
// //     font-weight: 700;
// //     color: #2c405a;
// //     white-space: nowrap;

// //     strong {
// //       color: #ff6d3c;
// //       font-weight: 900;
// //     }
// //   }

// //   & > button {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     height: 42px;
// //     width: 100px;
// //     background: none;
// //     color: #2c405a;
// //     margin-left: 4px;
// //     text-transform: uppercase;
// //   }

// //   @media (max-width: 700px) {
// //     & > h4 {
// //       display: none;
// //     }
// //   }
// // `;

// // User.Login = styled.button`
// //   display: flex;
// //   align-items: center;
// //   gap: 6px;
// //   border: 0;
// //   border-radius: 12px;
// //   padding: 0 14px;
// //   color: #2c405a;
// //   background: transparent;
// //   transition: background 0.22s ease, color 0.22s ease;

// //   > svg {
// //     height: 18px;
// //     width: 18px;
// //   }

// //   &:hover {
// //     background: rgba(255, 109, 60, 0.1);
// //     color: ${darken(0.06, '#ff6d3c')};
// //   }
// // `;

// // User.Signin = styled.button`
// //   border: 1px solid #ff6d3c;
// //   border-radius: 12px;
// //   padding: 0 16px;
// //   color: #ff6d3c;
// //   background: transparent;
// //   font-weight: 800;
// //   transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
// //     transform 0.22s ease;

// //   &:hover {
// //     color: #fff;
// //     background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%);
// //     box-shadow: 0 12px 26px rgba(255, 109, 60, 0.38);
// //     transform: translateY(-1px);

// //     > h5 {
// //       color: #fff;
// //     }
// //   }
// // `;

// // export const CartMenu = styled.div`
// //   position: relative;

// //   + div {
// //     margin-left: 4px;
// //   }

// //   > button {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     height: 44px;
// //     width: 44px;
// //     border: 0;
// //     border-radius: 14px;
// //     background: rgba(247, 250, 253, 0.6);
// //     color: #2c405a;
// //     transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
// //       transform 0.22s ease;

// //     + button {
// //       margin-left: 8px;
// //     }

// //     &:hover {
// //       color: #ff6d3c;
// //       background: rgba(255, 109, 60, 0.12);
// //       box-shadow: 0 10px 24px rgba(255, 109, 60, 0.18);
// //       transform: translateY(-1px);

// //       /* badge (irmão posterior ao botão) */
// //       /* & ~ span {
// //         transform: translateY(-1px);
// //       } */
// //     }

// //     &:active {
// //       transform: translateY(0);
// //     }
// //   }

// //   > span {
// //     position: absolute;
// //     top: 2px;
// //     right: 1px;
// //     z-index: 2;

// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     min-width: 18px;
// //     height: 18px;
// //     padding: 0 4px;
// //     border-radius: 999px;

// //     background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 100%);
// //     box-shadow: 0 4px 12px rgba(255, 109, 60, 0.5),
// //       0 0 0 2px rgba(255, 255, 255, 0.95);

// //     color: #fff;
// //     text-align: center;
// //     font-size: 10px;
// //     font-weight: 900;
// //     line-height: 1;

// //     transition: transform 0.22s ease;
// //     /* animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1) both; */
// //     animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1);
// //   }

// //   &:hover > span {
// //     /* transform: translateY(-2px) !important; */
// //     transform: translate(4px, -4px) rotate(8deg) !important;
// //   }
// // `;

// import styled, { keyframes } from 'styled-components';
// import { darken } from 'polished';

// /* ===== Paleta / identidade visual (alinhada às telas de login) =====
//    --primary:        #ff6d3c
//    --primary-strong: #e95a2d
//    --blue:           #1789dd
//    --text:           #17263b / #2c405a
//    --muted:          rgba(44, 64, 90, 0.55)
//    --border:         rgba(216, 224, 235, 0.9)
// ==================================================================== */

// const fadeDown = keyframes`
//   from { opacity: 0; }
//   to   { opacity: 1; }
// `;

// const dropIn = keyframes`
//   from { opacity: 0; transform: translateX(-50%) translateY(-8px) scale(0.97); }
//   to   { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
// `;

// const badgePop = keyframes`
//   0%   { transform: scale(0); }
//   60%  { transform: scale(1.18); }
//   100% { transform: scale(1); }
// `;

// export const Container = styled.nav`
//   position: relative;
//   z-index: 1;
//   display: flex;
//   align-items: center;
//   min-height: 76px;
//   padding: 0 26px;
//   margin: 0 auto;
//   width: 100%;
//   max-width: 2000px;

//   background: linear-gradient(
//     180deg,
//     rgba(255, 255, 255, 0.96) 0%,
//     rgba(247, 250, 253, 0.94) 100%
//   );
//   border-bottom: 1px solid rgba(216, 224, 235, 0.7);
//   box-shadow: 0 10px 32px rgba(23, 38, 59, 0.08),
//     0 1px 0 rgba(255, 255, 255, 0.9) inset;
//   animation: ${fadeDown} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;

//   /* fina linha de acento na base, no degradê da marca */
//   &::after {
//     content: '';
//     position: absolute;
//     left: 0;
//     right: 0;
//     bottom: -1px;
//     height: 2px;
//     background: linear-gradient(rgba(23, 137, 221, 0.5) 100%);
//     opacity: 0.85;
//     pointer-events: none;
//   }

//   img {
//     max-height: 56px;
//     width: auto;
//     transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), filter 0.3s ease;

//     &:hover {
//       transform: translateY(-1px) scale(1.02);
//       filter: drop-shadow(0 8px 18px rgba(23, 38, 59, 0.16));
//     }
//   }

//   & > ul {
//     flex: 1;
//     display: flex;
//     align-items: center;
//     gap: 4px;
//     padding: 0 22px;
//     height: 100%;

//     /* separador "|" entre grupos do menu, repaginado como divisor suave */
//     & > span {
//       width: 1px;
//       height: 24px;
//       margin: 0 12px;
//       color: transparent;
//       background: linear-gradient(
//         180deg,
//         transparent,
//         rgba(44, 64, 90, 0.22),
//         transparent
//       );
//       overflow: hidden;
//     }
//   }

//   @media (max-width: 900px) {
//     padding: 0 16px;

//     & > ul {
//       padding: 0 10px;
//       gap: 2px;
//     }

//     img {
//       max-height: 46px;
//     }
//   }
// `;

// export const Menu = styled.li`
//   position: relative;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 100%;
//   min-width: 120px;

//   font-size: 13px;
//   font-weight: 800;
//   letter-spacing: 0.4px;
//   text-transform: uppercase;

//   & + li {
//     margin-left: 6px;
//   }

//   /* pílula de fundo para item ativo / hover */
//   a,
//   .bi-menu-button {
//     position: relative;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 4px;
//     padding: 10px 16px;
//     border-radius: 12px;

//     color: ${(props) =>
//       props.selected ? '#1f2f46' : 'rgba(44, 64, 90, 0.55)'};
//     background: ${(props) =>
//       props.selected ? 'rgba(255, 109, 60, 0.1)' : 'transparent'};

//     transition: color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease,
//       transform 0.22s ease;

//     &:hover {
//       color: ${darken(0.08, '#1f2f46')};
//       background: rgba(255, 109, 60, 0.2);
//       transform: translateY(-1px);
//     }
//   }

//   /* indicador inferior animado (substitui o border-bottom antigo) */
//   a::after,
//   .bi-menu-button::after {
//     content: '';
//     position: absolute;
//     left: 50%;
//     bottom: -2px;
//     height: 1px;
//     width: ${(props) => (props.selected ? '60%' : '0')};
//     border-radius: 999px;
//     background: linear-gradient(90deg, #ff6d3c, #ff9b78);
//     box-shadow: 0 4px 12px rgba(255, 109, 60, 0.45);
//     transform: translateX(-50%);
//     transition: width 0.28s cubic-bezier(0.22, 1, 0.36, 1);
//   }

//   a:hover::after,
//   .bi-menu-button:hover::after {
//     width: 80%;
//   }

//   /* ===== Botão "BI" ===== */
//   .bi-menu-button {
//     border: 0;
//     font: inherit;
//     font-size: 13px;
//     font-weight: 800;
//     letter-spacing: 0.4px;
//     text-transform: uppercase;
//     cursor: pointer;

//     svg {
//       transition: transform 0.25s ease;
//     }

//     &:hover svg {
//       transform: translateY(1px);
//     }
//   }

//   /* ===== Dropdown do BI ===== */
//   .bi-menu-dropdown {
//     position: absolute;
//     top: calc(100% + 10px);
//     left: 50%;
//     transform: translateX(-50%);
//     z-index: 9999;

//     min-width: 224px;
//     max-width: 300px;
//     padding: 8px;

//     background: rgba(255, 255, 255, 0.98);
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     border-radius: 16px;
//     box-shadow: 0 24px 60px rgba(23, 38, 59, 0.18),
//       0 1px 0 rgba(255, 255, 255, 0.9) inset;
//     backdrop-filter: blur(20px);
//     animation: ${dropIn} 0.22s cubic-bezier(0.22, 1, 0.36, 1) both;

//     /* seta apontando para o botão */
//     &::before {
//       content: '';
//       position: absolute;
//       top: -6px;
//       left: 50%;
//       width: 12px;
//       height: 12px;
//       transform: translateX(-50%) rotate(45deg);
//       background: rgba(255, 255, 255, 0.98);
//       border-left: 1px solid rgba(216, 224, 235, 0.9);
//       border-top: 1px solid rgba(216, 224, 235, 0.9);
//     }

//     button {
//       position: relative;
//       display: flex;
//       flex-direction: row;
//       align-items: center;
//       gap: 10px;

//       width: 100%;
//       border: 0;
//       border-radius: 11px;
//       padding: 11px 13px;
//       background: transparent;

//       text-align: left;
//       text-transform: none;
//       letter-spacing: 0;
//       font-size: 13px;
//       font-weight: 700;
//       color: #3a4d66;
//       cursor: pointer;

//       transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;

//       svg {
//         flex-shrink: 0;
//         color: #ff6d3c;
//         transition: transform 0.2s ease;
//       }

//       &:hover {
//         color: #17263b;
//         background: rgba(255, 109, 60, 0.1);
//         transform: translateX(2px);

//         svg {
//           transform: scale(1.12) rotate(-6deg);
//         }
//       }
//     }
//   }

//   @media (max-width: 900px) {
//     min-width: auto;

//     a,
//     .bi-menu-button {
//       padding: 8px 11px;
//       font-size: 12px;
//     }
//   }
// `;

// export const User = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 4px;

//   & > h4 {
//     padding: 8px 14px;
//     border-radius: 999px;
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     background: rgba(247, 250, 253, 0.8);

//     font-size: 13px;
//     font-weight: 700;
//     color: #2c405a;
//     white-space: nowrap;

//     strong {
//       color: #ff6d3c;
//       font-weight: 900;
//     }
//   }

//   & > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 42px;
//     width: 100px;
//     background: none;
//     color: #2c405a;
//     margin-left: 4px;
//     text-transform: uppercase;
//   }

//   @media (max-width: 700px) {
//     & > h4 {
//       display: none;
//     }
//   }
// `;

// User.Login = styled.button`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   border: 0;
//   border-radius: 12px;
//   padding: 0 14px;
//   color: #2c405a;
//   background: transparent;
//   transition: background 0.22s ease, color 0.22s ease;

//   > svg {
//     height: 18px;
//     width: 18px;
//   }

//   &:hover {
//     background: rgba(255, 109, 60, 0.1);
//     color: ${darken(0.06, '#ff6d3c')};
//   }
// `;

// User.Signin = styled.button`
//   border: 1px solid #ff6d3c;
//   border-radius: 12px;
//   padding: 0 16px;
//   color: #ff6d3c;
//   background: transparent;
//   font-weight: 800;
//   transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
//     transform 0.22s ease;

//   &:hover {
//     color: #fff;
//     background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%);
//     box-shadow: 0 12px 26px rgba(255, 109, 60, 0.38);
//     transform: translateY(-1px);

//     > h5 {
//       color: #fff;
//     }
//   }
// `;

// export const CartMenu = styled.div`
//   position: relative;

//   + div {
//     margin-left: 4px;
//   }

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 44px;
//     width: 44px;
//     border: 0;
//     border-radius: 14px;
//     background: rgba(247, 250, 253, 0.6);
//     color: #2c405a;
//     transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
//       transform 0.22s ease;

//     + button {
//       margin-left: 8px;
//     }

//     &:hover {
//       color: #ff6d3c;
//       background: rgba(255, 109, 60, 0.12);
//       box-shadow: 0 10px 24px rgba(255, 109, 60, 0.18);
//       transform: translateY(-1px);

//       /* badge (irmão posterior ao botão) */
//       /* & ~ span {
//         transform: translateY(-1px);
//       } */
//     }

//     &:active {
//       transform: translateY(0);
//     }
//   }

//   > span {
//     position: absolute;
//     top: 2px;
//     right: 1px;
//     z-index: 2;

//     display: flex;
//     align-items: center;
//     justify-content: center;
//     min-width: 18px;
//     height: 18px;
//     padding: 0 4px;
//     border-radius: 999px;

//     background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 100%);
//     box-shadow: 0 4px 12px rgba(255, 109, 60, 0.5),
//       0 0 0 2px rgba(255, 255, 255, 0.95);

//     color: #fff;
//     text-align: center;
//     font-size: 10px;
//     font-weight: 900;
//     line-height: 1;

//     transition: transform 0.22s ease;
//     /* animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1) both; */
//     animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1);
//   }

//   &:hover > span {
//     /* transform: translateY(-2px) !important; */
//     transform: translate(4px, -4px) rotate(8deg) !important;
//   }
// `;

// import styled, { keyframes } from 'styled-components';
// import { darken } from 'polished';

// /* ===== Paleta / identidade visual (alinhada às telas de login) =====
//    --primary:        #ff6d3c
//    --primary-strong: #e95a2d
//    --blue:           #1789dd
//    --text:           #17263b / #2c405a
//    --muted:          rgba(44, 64, 90, 0.55)
//    --border:         rgba(216, 224, 235, 0.9)
// ==================================================================== */

// const fadeDown = keyframes`
//   from { opacity: 0; }
//   to   { opacity: 1; }
// `;

// const dropIn = keyframes`
//   from { opacity: 0; transform: translateX(-50%) translateY(-8px) scale(0.97); }
//   to   { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
// `;

// const badgePop = keyframes`
//   0%   { transform: scale(0); }
//   60%  { transform: scale(1.18); }
//   100% { transform: scale(1); }
// `;

// export const Container = styled.nav`
//   position: relative;
//   z-index: 1;
//   display: flex;
//   align-items: center;
//   min-height: 76px;
//   padding: 0 26px;
//   margin: 0 auto;
//   width: 100%;
//   max-width: 2000px;

//   background: linear-gradient(
//     180deg,
//     rgba(255, 255, 255, 0.96) 0%,
//     rgba(247, 250, 253, 0.94) 100%
//   );
//   border-bottom: 1px solid rgba(216, 224, 235, 0.7);
//   box-shadow: 0 10px 32px rgba(23, 38, 59, 0.08),
//     0 1px 0 rgba(255, 255, 255, 0.9) inset;
//   animation: ${fadeDown} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;

//   /* fina linha de acento na base, no degradê da marca */
//   &::after {
//     content: '';
//     position: absolute;
//     left: 0;
//     right: 0;
//     bottom: -1px;
//     height: 2px;
//     background: linear-gradient(rgba(23, 137, 221, 0.5) 100%);
//     opacity: 0.85;
//     pointer-events: none;
//   }

//   img {
//     max-height: 56px;
//     width: auto;
//     transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), filter 0.3s ease;

//     &:hover {
//       transform: translateY(-1px) scale(1.02);
//       filter: drop-shadow(0 8px 18px rgba(23, 38, 59, 0.16));
//     }
//   }

//   & > ul {
//     flex: 1;
//     display: flex;
//     align-items: center;
//     gap: 4px;
//     padding: 0 22px;
//     height: 100%;

//     /* separador "|" entre grupos do menu, repaginado como divisor suave */
//     & > span {
//       width: 1px;
//       height: 24px;
//       margin: 0 12px;
//       color: transparent;
//       background: linear-gradient(
//         180deg,
//         transparent,
//         rgba(44, 64, 90, 0.22),
//         transparent
//       );
//       overflow: hidden;
//     }
//   }

//   @media (max-width: 900px) {
//     padding: 0 16px;

//     & > ul {
//       padding: 0 10px;
//       gap: 2px;
//     }

//     img {
//       max-height: 46px;
//     }
//   }
// `;

// export const Menu = styled.li`
//   position: relative;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 100%;
//   min-width: 120px;

//   font-size: 13px;
//   font-weight: 800;
//   letter-spacing: 0.4px;
//   text-transform: uppercase;

//   & + li {
//     margin-left: 6px;
//   }

//   /* pílula de fundo para item ativo / hover */
//   a,
//   .bi-menu-button {
//     position: relative;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 4px;
//     padding: 10px 16px;
//     border-radius: 12px;

//     color: ${(props) =>
//       props.selected ? '#1f2f46' : 'rgba(44, 64, 90, 0.55)'};
//     background: ${(props) =>
//       props.selected ? 'rgba(255, 109, 60, 0.1)' : 'transparent'};

//     transition: color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease,
//       transform 0.22s ease;

//     &:hover {
//       color: ${darken(0.08, '#1f2f46')};
//       background: rgba(255, 109, 60, 0.2);
//       transform: translateY(-1px);
//     }
//   }

//   /* indicador inferior animado (substitui o border-bottom antigo) */
//   a::after,
//   .bi-menu-button::after {
//     content: '';
//     position: absolute;
//     left: 50%;
//     bottom: -2px;
//     height: 1px;
//     width: ${(props) => (props.selected ? '60%' : '0')};
//     border-radius: 999px;
//     background: linear-gradient(90deg, #ff6d3c, #ff9b78);
//     box-shadow: 0 4px 12px rgba(255, 109, 60, 0.45);
//     transform: translateX(-50%);
//     transition: width 0.28s cubic-bezier(0.22, 1, 0.36, 1);
//   }

//   a:hover::after,
//   .bi-menu-button:hover::after {
//     width: 80%;
//   }

//   /* ===== Botão "BI" ===== */
//   .bi-menu-button {
//     border: 0;
//     font: inherit;
//     font-size: 13px;
//     font-weight: 800;
//     letter-spacing: 0.4px;
//     text-transform: uppercase;
//     cursor: pointer;

//     svg {
//       transition: transform 0.25s ease;
//     }

//     &:hover svg {
//       transform: translateY(1px);
//     }
//   }

//   /* ===== Dropdown do BI ===== */
//   .bi-menu-dropdown {
//     position: absolute;
//     top: calc(100% + 10px);
//     left: 50%;
//     transform: translateX(-50%);
//     z-index: 9999;

//     min-width: 224px;
//     max-width: 300px;
//     padding: 8px;

//     background: rgba(255, 255, 255, 0.98);
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     border-radius: 16px;
//     box-shadow: 0 24px 60px rgba(23, 38, 59, 0.18),
//       0 1px 0 rgba(255, 255, 255, 0.9) inset;
//     backdrop-filter: blur(20px);
//     animation: ${dropIn} 0.22s cubic-bezier(0.22, 1, 0.36, 1) both;

//     /* seta apontando para o botão */
//     &::before {
//       content: '';
//       position: absolute;
//       top: -6px;
//       left: 50%;
//       width: 12px;
//       height: 12px;
//       transform: translateX(-50%) rotate(45deg);
//       background: rgba(255, 255, 255, 0.98);
//       border-left: 1px solid rgba(216, 224, 235, 0.9);
//       border-top: 1px solid rgba(216, 224, 235, 0.9);
//     }

//     button {
//       position: relative;
//       display: flex;
//       flex-direction: row;
//       align-items: center;
//       gap: 10px;

//       width: 100%;
//       border: 0;
//       border-radius: 11px;
//       padding: 11px 13px;
//       background: transparent;

//       text-align: left;
//       text-transform: none;
//       letter-spacing: 0;
//       font-size: 13px;
//       font-weight: 700;
//       color: #3a4d66;
//       cursor: pointer;

//       transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;

//       svg {
//         flex-shrink: 0;
//         color: #ff6d3c;
//         transition: transform 0.2s ease;
//       }

//       &:hover {
//         color: #17263b;
//         background: rgba(255, 109, 60, 0.1);
//         transform: translateX(2px);

//         svg {
//           transform: scale(1.12) rotate(-6deg);
//         }
//       }
//     }
//   }

//   @media (max-width: 900px) {
//     min-width: auto;

//     a,
//     .bi-menu-button {
//       padding: 8px 11px;
//       font-size: 12px;
//     }
//   }
// `;

// export const User = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 4px;

//   & > h4 {
//     padding: 8px 14px;
//     border-radius: 999px;
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     background: rgba(247, 250, 253, 0.8);

//     font-size: 13px;
//     font-weight: 700;
//     color: #2c405a;
//     white-space: nowrap;

//     strong {
//       color: #ff6d3c;
//       font-weight: 900;
//     }
//   }

//   & > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 42px;
//     width: 100px;
//     background: none;
//     color: #2c405a;
//     margin-left: 4px;
//     text-transform: uppercase;
//   }

//   @media (max-width: 700px) {
//     & > h4 {
//       display: none;
//     }
//   }
// `;

// User.Login = styled.button`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   border: 0;
//   border-radius: 12px;
//   padding: 0 14px;
//   color: #2c405a;
//   background: transparent;
//   transition: background 0.22s ease, color 0.22s ease;

//   > svg {
//     height: 18px;
//     width: 18px;
//   }

//   &:hover {
//     background: rgba(255, 109, 60, 0.1);
//     color: ${darken(0.06, '#ff6d3c')};
//   }
// `;

// User.Signin = styled.button`
//   border: 1px solid #ff6d3c;
//   border-radius: 12px;
//   padding: 0 16px;
//   color: #ff6d3c;
//   background: transparent;
//   font-weight: 800;
//   transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
//     transform 0.22s ease;

//   &:hover {
//     color: #fff;
//     background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%);
//     box-shadow: 0 12px 26px rgba(255, 109, 60, 0.38);
//     transform: translateY(-1px);

//     > h5 {
//       color: #fff;
//     }
//   }
// `;

// export const CartMenu = styled.div`
//   position: relative;

//   + div {
//     margin-left: 4px;
//   }

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 44px;
//     width: 44px;
//     border: 0;
//     border-radius: 14px;
//     background: rgba(247, 250, 253, 0.6);
//     color: #2c405a;
//     transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
//       transform 0.22s ease;

//     + button {
//       margin-left: 8px;
//     }

//     &:hover {
//       color: #ff6d3c;
//       background: rgba(255, 109, 60, 0.12);
//       box-shadow: 0 10px 24px rgba(255, 109, 60, 0.18);
//       transform: translateY(-1px);

//       /* badge (irmão posterior ao botão) */
//       /* & ~ span {
//         transform: translateY(-1px);
//       } */
//     }

//     &:active {
//       transform: translateY(0);
//     }
//   }

//   > span {
//     position: absolute;
//     top: 2px;
//     right: 1px;
//     z-index: 2;

//     display: flex;
//     align-items: center;
//     justify-content: center;
//     min-width: 18px;
//     height: 18px;
//     padding: 0 4px;
//     border-radius: 999px;

//     background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 100%);
//     box-shadow: 0 4px 12px rgba(255, 109, 60, 0.5),
//       0 0 0 2px rgba(255, 255, 255, 0.95);

//     color: #fff;
//     text-align: center;
//     font-size: 10px;
//     font-weight: 900;
//     line-height: 1;

//     transition: transform 0.22s ease;
//     /* animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1) both; */
//     animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1);
//   }

//   &:hover > span {
//     /* transform: translateY(-2px) !important; */
//     transform: translate(4px, -4px) rotate(8deg) !important;
//   }
// `;

import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

/* ===== Paleta / identidade visual (alinhada às telas de login) =====
   --primary:        #ff6d3c
   --primary-strong: #e95a2d
   --blue:           #1789dd
   --text:           #17263b / #2c405a
   --muted:          rgba(44, 64, 90, 0.55)
   --border:         rgba(216, 224, 235, 0.9)
==================================================================== */

const fadeDown = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const dropIn = keyframes`
  from { opacity: 0; transform: translateX(-50%) translateY(-8px) scale(0.97); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
`;

const badgePop = keyframes`
  0%   { transform: scale(0); }
  60%  { transform: scale(1.18); }
  100% { transform: scale(1); }
`;

export const Container = styled.nav`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;

  /**
   * Altura controlada pela variável global --app-header-h (styles/global.js).
   * Em tablets / telas de baixa altura ela cai de 76px para 54px, liberando
   * espaço vertical para o conteúdo. flex-shrink: 0 evita que o header seja
   * comprimido pelo Wrapper do layout.
   */
  flex: 0 0 auto;
  height: var(--app-header-h);
  min-height: var(--app-header-h);
  padding: 0 26px;
  margin: 0 auto;
  width: 100%;
  max-width: 2000px;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(247, 250, 253, 0.94) 100%
  );
  border-bottom: 1px solid rgba(216, 224, 235, 0.7);
  box-shadow: 0 10px 32px rgba(23, 38, 59, 0.08),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;
  animation: ${fadeDown} 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;

  /* fina linha de acento na base, no degradê da marca */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background: linear-gradient(rgba(23, 137, 221, 0.5) 100%);
    opacity: 0.85;
    pointer-events: none;
  }

  img {
    max-height: 56px;
    width: auto;
    transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), filter 0.3s ease;

    &:hover {
      transform: translateY(-1px) scale(1.02);
      filter: drop-shadow(0 8px 18px rgba(23, 38, 59, 0.16));
    }
  }

  & > ul {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 22px;
    height: 100%;

    /** o menu não deve empurrar a área do usuário / carrinho */
    min-width: 0;
    overflow: visible;

    /* separador "|" entre grupos do menu, repaginado como divisor suave */
    & > span {
      width: 1px;
      height: 24px;
      margin: 0 12px;
      color: transparent;
      background: linear-gradient(
        180deg,
        transparent,
        rgba(44, 64, 90, 0.22),
        transparent
      );
      overflow: hidden;
    }
  }

  /** ===== Modo compacto: tablets / telas de baixa altura (1340 x 800) ===== */
  @media (max-width: 1440px), (max-height: 900px) {
    padding: 0 14px;

    img {
      max-height: 38px;
    }

    & > ul {
      padding: 0 10px;
      gap: 2px;

      & > span {
        height: 18px;
        margin: 0 6px;
      }
    }
  }

  @media (max-width: 900px) {
    padding: 0 16px;

    & > ul {
      padding: 0 10px;
      gap: 2px;
    }

    img {
      max-height: 36px;
    }
  }
`;

export const Menu = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 120px;

  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;

  & + li {
    margin-left: 6px;
  }

  /* pílula de fundo para item ativo / hover */
  a,
  .bi-menu-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 10px 16px;
    border-radius: 12px;

    color: ${(props) =>
      props.selected ? '#1f2f46' : 'rgba(44, 64, 90, 0.55)'};
    background: ${(props) =>
      props.selected ? 'rgba(255, 109, 60, 0.1)' : 'transparent'};

    transition: color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease,
      transform 0.22s ease;

    &:hover {
      color: ${darken(0.08, '#1f2f46')};
      background: rgba(255, 109, 60, 0.2);
      transform: translateY(-1px);
    }
  }

  /* indicador inferior animado (substitui o border-bottom antigo) */
  a::after,
  .bi-menu-button::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -2px;
    height: 1px;
    width: ${(props) => (props.selected ? '60%' : '0')};
    border-radius: 999px;
    background: linear-gradient(90deg, #ff6d3c, #ff9b78);
    box-shadow: 0 4px 12px rgba(255, 109, 60, 0.45);
    transform: translateX(-50%);
    transition: width 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  }

  a:hover::after,
  .bi-menu-button:hover::after {
    width: 80%;
  }

  /* ===== Botão "BI" ===== */
  .bi-menu-button {
    border: 0;
    font: inherit;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    cursor: pointer;

    svg {
      transition: transform 0.25s ease;
    }

    &:hover svg {
      transform: translateY(1px);
    }
  }

  /* ===== Dropdown do BI ===== */
  .bi-menu-dropdown {
    position: absolute;
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;

    min-width: 224px;
    max-width: 300px;
    padding: 8px;

    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 16px;
    box-shadow: 0 24px 60px rgba(23, 38, 59, 0.18),
      0 1px 0 rgba(255, 255, 255, 0.9) inset;
    backdrop-filter: blur(20px);
    animation: ${dropIn} 0.22s cubic-bezier(0.22, 1, 0.36, 1) both;

    /* seta apontando para o botão */
    &::before {
      content: '';
      position: absolute;
      top: -6px;
      left: 50%;
      width: 12px;
      height: 12px;
      transform: translateX(-50%) rotate(45deg);
      background: rgba(255, 255, 255, 0.98);
      border-left: 1px solid rgba(216, 224, 235, 0.9);
      border-top: 1px solid rgba(216, 224, 235, 0.9);
    }

    button {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;

      width: 100%;
      border: 0;
      border-radius: 11px;
      padding: 11px 13px;
      background: transparent;

      text-align: left;
      text-transform: none;
      letter-spacing: 0;
      font-size: 13px;
      font-weight: 700;
      color: #3a4d66;
      cursor: pointer;

      transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;

      svg {
        flex-shrink: 0;
        color: #ff6d3c;
        transition: transform 0.2s ease;
      }

      &:hover {
        color: #17263b;
        background: rgba(255, 109, 60, 0.1);
        transform: translateX(2px);

        svg {
          transform: scale(1.12) rotate(-6deg);
        }
      }
    }
  }

  /** ===== Modo compacto: tablets / telas de baixa altura (1340 x 800) ===== */
  @media (max-width: 1440px), (max-height: 900px) {
    min-width: auto;
    font-size: 12px;

    & + li {
      margin-left: 2px;
    }

    a,
    .bi-menu-button {
      padding: 7px 10px;
      border-radius: 10px;
      font-size: 12px;
      white-space: nowrap;
    }
  }

  @media (max-width: 900px) {
    min-width: auto;

    a,
    .bi-menu-button {
      padding: 8px 11px;
      font-size: 12px;
    }
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  & > h4 {
    padding: 8px 14px;
    border-radius: 999px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    background: rgba(247, 250, 253, 0.8);

    font-size: 13px;
    font-weight: 700;
    color: #2c405a;
    white-space: nowrap;

    strong {
      color: #ff6d3c;
      font-weight: 900;
    }
  }

  & > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 100px;
    background: none;
    color: #2c405a;
    margin-left: 4px;
    text-transform: uppercase;
  }

  /** ===== Modo compacto: tablets / telas de baixa altura (1340 x 800) ===== */
  @media (max-width: 1440px), (max-height: 900px) {
    & > h4 {
      padding: 5px 10px;
      font-size: 12px;

      /** mantém a saudação enxuta, sem quebrar a linha do header */
      max-width: 190px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & > button {
      height: 34px;
      width: 78px;
      font-size: 12px;
    }
  }

  @media (max-width: 700px) {
    & > h4 {
      display: none;
    }
  }
`;

User.Login = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 12px;
  padding: 0 14px;
  color: #2c405a;
  background: transparent;
  transition: background 0.22s ease, color 0.22s ease;

  > svg {
    height: 18px;
    width: 18px;
  }

  &:hover {
    background: rgba(255, 109, 60, 0.1);
    color: ${darken(0.06, '#ff6d3c')};
  }
`;

User.Signin = styled.button`
  border: 1px solid #ff6d3c;
  border-radius: 12px;
  padding: 0 16px;
  color: #ff6d3c;
  background: transparent;
  font-weight: 800;
  transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
    transform 0.22s ease;

  &:hover {
    color: #fff;
    background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%);
    box-shadow: 0 12px 26px rgba(255, 109, 60, 0.38);
    transform: translateY(-1px);

    > h5 {
      color: #fff;
    }
  }
`;

export const CartMenu = styled.div`
  position: relative;

  + div {
    margin-left: 4px;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    width: 44px;
    border: 0;
    border-radius: 14px;
    background: rgba(247, 250, 253, 0.6);
    color: #2c405a;
    transition: background 0.22s ease, color 0.22s ease, box-shadow 0.22s ease,
      transform 0.22s ease;

    + button {
      margin-left: 8px;
    }

    &:hover {
      color: #ff6d3c;
      background: rgba(255, 109, 60, 0.12);
      box-shadow: 0 10px 24px rgba(255, 109, 60, 0.18);
      transform: translateY(-1px);

      /* badge (irmão posterior ao botão) */
      /* & ~ span {
        transform: translateY(-1px);
      } */
    }

    &:active {
      transform: translateY(0);
    }
  }

  > span {
    position: absolute;
    top: 2px;
    right: 1px;
    z-index: 2;

    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 999px;

    background: linear-gradient(135deg, #ff6d3c 0%, #ff875f 100%);
    box-shadow: 0 4px 12px rgba(255, 109, 60, 0.5),
      0 0 0 2px rgba(255, 255, 255, 0.95);

    color: #fff;
    text-align: center;
    font-size: 10px;
    font-weight: 900;
    line-height: 1;

    transition: transform 0.22s ease;
    /* animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1) both; */
    animation: ${badgePop} 0.35s cubic-bezier(0.22, 1.4, 0.4, 1);
  }

  &:hover > span {
    /* transform: translateY(-2px) !important; */
    transform: translate(4px, -4px) rotate(8deg) !important;
  }

  /**
   * Modo compacto: tablets / telas de baixa altura (1340 x 800).
   * 38px mantém o alvo de toque confortável com o header de 54px.
   */
  @media (max-width: 1440px), (max-height: 900px) {
    > button {
      height: 38px;
      width: 38px;
      border-radius: 12px;

      + button {
        margin-left: 4px;
      }
    }
  }
`;
